export default {"src":"/_next/static/media/WFC.6ea22378.svg","height":18,"width":18};